/**
 * The media-domain allowlist's routes (ACP-D52; `graphicsMediaDomains.ts`; spread into `ROUTES` by `routes.ts`). Cloud
 * only, like the Mimir settings they sit beside: `apps/cloud-api/src/graphics/mediaDomains.ts`.
 */
import { graphicsMediaDomainsWireSchema, updateGraphicsMediaDomainsRequestWireSchema } from './graphicsMediaDomains.js';
import type { RouteDef } from './routes.js';

export const GRAPHICS_MEDIA_DOMAINS_ROUTES = {
  getGraphicsMediaDomains: {
    id: 'getGraphicsMediaDomains',
    method: 'GET',
    path: '/graphics/settings/media-domains',
    tag: 'graphics',
    summary: 'Get the tenant’s media-domain allowlist',
    description:
      'The hosts dynamic images may be fetched from for this tenant (ACP-D52): exact hosts (`cdn.example.com`) and wildcards (`*.example.com`, subdomains only). A renderer fetches from these directly when they answer with CORS, and the image fetch proxy of a control session contacts no other host. Empty when none were saved. Needs `graphics.read`.',
    params: null,
    query: null,
    body: null,
    response: graphicsMediaDomainsWireSchema,
    successStatus: 200,
    permission: 'graphics.read',
    permissionScope: 'tenant',
    errors: [],
  },
  updateGraphicsMediaDomains: {
    id: 'updateGraphicsMediaDomains',
    method: 'PUT',
    path: '/graphics/settings/media-domains',
    tag: 'graphics',
    summary: 'Save the tenant’s media-domain allowlist',
    description:
      'Replaces the whole list (last write wins; saved sorted and de-duplicated, at most 100). `validation-failed` naming `domains/<n>` for a pattern that is not an exact host or `*.domain` wildcard: IP addresses, ports, schemes, paths, a wildcard beyond the first label and `*.<tld>` are refused. Renderers already joined learn the new list at their next join or resume; the proxy reads it on every fetch. Needs `graphics.admin`.',
    params: null,
    query: null,
    body: updateGraphicsMediaDomainsRequestWireSchema,
    response: graphicsMediaDomainsWireSchema,
    successStatus: 200,
    permission: 'graphics.admin',
    permissionScope: 'tenant',
    errors: ['bad-request', 'validation-failed'],
  },
} as const satisfies Record<string, RouteDef>;
